var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOpenData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_open-data",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#413e56;}.cls-1,.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-2,.cls-3{stroke:#1d1d1b;}.cls-3,.cls-5{fill:#fff;}.cls-4{fill:#403e56;}.cls-5{stroke:#fff;stroke-miterlimit:10;}.cls-6{fill:#f2f2f2;}.cls-7{fill:#4ab382;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_open-data") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrows"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "63.62 122.38 83.2 122.38 83.2 87.35 97.68 87.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.68 75.51 69.54 75.51 69.54 64.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "195.45 69.27 219.33 69.27 219.33 58.53 244.47 58.53 244.47 53.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "195.45 93.97 213.55 93.97 213.55 118.38 229.73 118.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "133.24 43.42 133.24 32.93 121.33 32.93 121.33 27.43"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 121.33,
    cy: 22.43,
    r: 4.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 160.54,
    y1: 43.42,
    x2: 160.54,
    y2: 37.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 160.54,
    cy: 32.93,
    r: 4.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.45,
    y1: 80.62,
    x2: 228.26,
    y2: 80.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 233.26,
    cy: 80.62,
    r: 4.48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "globe"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 254.14,
    cy: 116.45,
    r: 18.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 254.14,
    cy: 116.45,
    rx: 9.66,
    ry: 18.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 254.14,
    y1: 134.61,
    x2: 254.14,
    y2: 98.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 270.95,
    y1: 123.41,
    x2: 237.35,
    y2: 123.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 235.97,
    y1: 116.45,
    x2: 272.3,
    y2: 116.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 270.92,
    y1: 109.5,
    x2: 237.35,
    y2: 109.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "book"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.1 132.19 16.07 123.48 28.99 87.35 55.05 95.08 43.1 132.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "16.07 123.48 16.07 128.81 43.2 137.51 43.2 132.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "55.05 95.14 55.05 100.46 43.2 137.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.33,
    y1: 98.06,
    x2: 41.62,
    y2: 100.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.44,
    y1: 103.03,
    x2: 40.73,
    y2: 105.66
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "satellite"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.82 41.12 47.9 43.83 30.74 58.42 21.94 46.31 41.12 34.49 41.82 41.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.55 23.68 59.37 35.5 58.67 28.88 52.58 26.16 69.75 11.57 78.55 23.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.76 39.23 51.33 45.36 47.9 43.83 41.82 41.12 41.12 34.49 40.73 30.76 49.16 24.64 52.58 26.16 58.67 28.88 59.37 35.5 59.76 39.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 55.55,
    y1: 42.29,
    x2: 57.93,
    y2: 45.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 59.67,
    cy: 47.97,
    r: 2.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.88,56.78c1.7.61,4.43-.06,6.87-1.83s3.91-4.15,3.85-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.81,61.72c2.06.34,5.73-1,9.27-3.58s5.93-5.63,6.24-7.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 70.54,
    y1: 24.15,
    x2: 66.84,
    y2: 19.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 65.81,
    y1: 26.15,
    x2: 63.47,
    y2: 22.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.79,
    y1: 46.63,
    x2: 35.45,
    y2: 43.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 34.36,
    y1: 50.43,
    x2: 30.66,
    y2: 45.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 34.36,
    y1: 50.43,
    x2: 30.66,
    y2: 45.33
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "259.6 29.13 258.78 36.92 252.24 36.23 251.55 42.78 243.76 41.96 244.45 35.41 237.91 34.73 238.72 26.94 245.27 27.63 245.96 21.08 253.74 21.9 253.06 28.45 259.6 29.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 231.83,
    y: 15.01,
    width: 33.85,
    height: 33.85,
    transform: "translate(4.7 -25.83) rotate(6)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "computer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188,50.68H105.17A3.14,3.14,0,0,0,102,53.81h0v55.82a3.15,3.15,0,0,0,3.14,3.14h31.45l-1.17,7.52s-6.74,3.58-2,3.69,27,0,27,0,4.32,0-2.52-3.79l-1.11-7.42H188a3.13,3.13,0,0,0,3.14-3.14h0V53.81A3.13,3.13,0,0,0,188,50.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 105.03,
    y: 53.99,
    width: 83.14,
    height: 46.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 146.6,
    cy: 108.51,
    r: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "f3c2397c-d780-4cc6-97d8-1503d8277a2c"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ad41612f-86f7-46b2-a964-3a5da7bcf3cf",
    className: "cls-7",
    x: 128.84,
    y: 69.27,
    width: 9.89,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b9a0b375-cc2a-4c59-8850-661af54e4f62",
    className: "cls-7",
    x: 169.51,
    y: 69.27,
    width: 3.48,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e174c2ab-9bc5-41ec-b37c-b06fbf8a9878",
    className: "cls-7",
    x: 176.48,
    y: 69.27,
    width: 3.48,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ba2479ac-4c7d-43b4-a028-73b1e20e4002",
    className: "cls-7",
    x: 142.21,
    y: 69.27,
    width: 23.64,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ac60ef86-00f2-480b-8171-28b6fdfc1958",
    className: "cls-7",
    x: 116.38,
    y: 84.66,
    width: 9.89,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b3d8298d-cd65-487a-8b19-4cee946356e7",
    className: "cls-7",
    x: 157.06,
    y: 84.66,
    width: 3.48,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ed27f15f-f0c4-4569-8330-a6688f8e356c",
    className: "cls-7",
    x: 164.02,
    y: 84.66,
    width: 3.48,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "f685c005-adaf-4d60-acda-005b037d82a6",
    className: "cls-7",
    x: 129.75,
    y: 84.66,
    width: 23.64,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "eca7c7fc-83f8-48ca-a588-6606db47af3f",
    className: "cls-7",
    x: 157.24,
    y: 74.58,
    width: 9.89,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a71b5b2f-f8b9-481d-a301-5e3357e5fe42",
    className: "cls-7",
    x: 170.61,
    y: 74.58,
    width: 9.89,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "abb3a25a-f854-41fc-8391-e6ad9fbe2417",
    className: "cls-7",
    x: 116.38,
    y: 74.58,
    width: 3.48,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "add2b425-b775-4eb5-9c25-8c4c14f957c9",
    className: "cls-7",
    x: 123.34,
    y: 74.58,
    width: 3.48,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b7159612-3b84-4b0b-a885-612eaab04c06",
    className: "cls-7",
    x: 130.3,
    y: 74.58,
    width: 23.64,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "edfc7301-4de5-47dc-80e2-1ae2da982d6d",
    className: "cls-7",
    x: 136.72,
    y: 79.71,
    width: 9.89,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e1009f91-6275-4375-80fa-0d778e331fdc",
    className: "cls-7",
    x: 123.34,
    y: 79.71,
    width: 9.89,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a060fb9f-1f1a-4862-9a69-16dd49199e18",
    className: "cls-7",
    x: 116.38,
    y: 79.71,
    width: 3.48,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b6754d5f-104f-449c-b9a9-cf9ac82bf5fe",
    className: "cls-7",
    x: 177.03,
    y: 79.71,
    width: 3.48,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e6ed1ccd-2cfd-450f-a339-07df3a1ee6bb",
    className: "cls-7",
    x: 149.91,
    y: 79.71,
    width: 23.64,
    height: 2.38
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenData);
export default __webpack_public_path__ + "static/media/icon_open-data.12b6055aac8d4c53ab1c7c2080aa08d3.svg";
export { ForwardRef as ReactComponent };